import * as React from 'react';
import cn from 'classnames';
import Amenities from '@websky/core/src/Amenities';
import { useTheme } from '@websky/core/src/theme';
import * as css from './SegmentPlaneInfo.css';
const SegmentPlaneInfo = ({ className, segment }) => {
    var _a, _b;
    const { SegmentStyles: theme } = useTheme('DesktopFlightRoute');
    console.log(segment);
    return (React.createElement("div", { className: cn(className, theme.planeInfo) },
        ((_a = segment.marketingAirline) === null || _a === void 0 ? void 0 : _a.icon) && React.createElement("img", { className: css.icon, src: segment.marketingAirline.icon }),
        React.createElement("div", { className: css.info },
            React.createElement("div", null,
                segment.operatingAirline.name,
                ", \u0440\u0435\u0439\u0441 ",
                segment.operatingAirline.iata,
                "-",
                segment.flightNumber),
            React.createElement("div", null,
                React.createElement("span", null, segment.aircraft.name),
                ((_b = segment === null || segment === void 0 ? void 0 : segment.flightInfo) === null || _b === void 0 ? void 0 : _b.amenities) && React.createElement(Amenities, { amenities: segment.flightInfo.amenities })))));
};
export default SegmentPlaneInfo;
